var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuidelinesDropdownChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#65F72A",
  d: "M7.958 14.646a.9.9 0 0 1-.312-.053.7.7 0 0 1-.271-.176L3.79 10.833a.77.77 0 0 1-.219-.594.84.84 0 0 1 .24-.593.8.8 0 0 1 .584-.23.8.8 0 0 1 .583.23l2.979 2.979 7.063-7.062a.8.8 0 0 1 .594-.23q.363 0 .593.23.23.228.23.593a.8.8 0 0 1-.23.594l-7.667 7.667a.7.7 0 0 1-.27.176.9.9 0 0 1-.313.053"
})));
export default SvgGuidelinesDropdownChecked;